import styled from '@emotion/styled';

import Button from '../button/Button';
import { RouterLink } from '../link/RouterLink';
import {
	ArrowForwardIcon,
	DownloadIcon,
	EmailIcon,
	ExternalLinkIcon,
	ICallToActionLink,
	PhoneIcon,
	Responsive,
} from '../../../ui';
import { ICallToActionTheme } from './ICallToActionTheme';

interface ICallToActionButtonAsLink {
	link: ICallToActionLink;
	ctaTheme: ICallToActionTheme;
	secondary: boolean;
	ariaLabel?: string;
}

export default function CallToActionLink({
	link,
	ctaTheme,
	secondary,
	ariaLabel,
}: ICallToActionButtonAsLink) {
	const ICON_MAP = {
		'email-link': <EmailIcon aria-hidden />,
		'external-link': <ExternalLinkIcon aria-hidden />,
		'internal-link': <ArrowForwardIcon aria-hidden />,
		'asset-link': <DownloadIcon aria-hidden />,
		'phone-link': <PhoneIcon aria-hidden />,
	};

	const inverted = ctaTheme === 'primary';
	let href = '';
	const icon = ICON_MAP[link.type];
	let number = '';

	const openNewTab =
		link.type === 'external-link' ||
		link.type === 'asset-link' ||
		link.type === 'email-link';

	switch (link.type) {
		case 'internal-link':
		case 'external-link':
		case 'asset-link':
			href = link.url;
			break;

		case 'email-link':
			href = `mailto:${link.address}`;
			break;

		case 'phone-link':
			href = `tel:${link.number}`;
			number = link.number;
			break;

		default:
			return null;
	}

	return (
		<StyledButton
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			as={link.type === 'internal-link' ? RouterLink : 'a'}
			href={href}
			target={openNewTab ? '_blank' : undefined}
			aria-label={`${ariaLabel || link.title} ${number || ''} ${
				openNewTab ? ' (opens in a new tab)' : ''
			}`}
			rel={openNewTab ? 'noopener noreferrer' : undefined}
			secondary={secondary}
			inverted={inverted}
			invertedSecondary={ctaTheme === 'orange'}
			icon={icon}
		>
			{link.title}
		</StyledButton>
	);
}

const StyledButton = styled(Button)`
	white-space: normal;
	text-decoration: none;

	> div {
		max-width: 250px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		span {
			display: none;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		> div {
			max-width: 215px;
		}
	}
`;
